<template>
  <div class="mobile_vote">
    <div class="mobile_vote_head">
      <div class="mobile_head_left">
        <a @click="goBack()">
          <i class="el-icon-arrow-left"></i>
        </a>
      </div>
      <span class="mobile_head_desc"> </span>
      <div class="mobile_head_right">
        <a @click="refreshList()">
          <i class="el-icon-refresh"></i>
        </a>
      </div>
    </div>
    <div class="mobile_vote_main" style="margin-top: 45px">
      <div
        v-for="(voteItem, voteIndex) in awardCeremonyScreenVoteList"
        :key="voteIndex"
        class="award_ceremony_item"
      >
        <div class="award_ceremony_item_head">
          <div
            v-html="voteItem.VoteName"
            class="award_ceremony_item_head_title"
          ></div>
          <el-button
            @click="openAwardCeremony(voteItem)"
            size="mini"
            plain
            v-if="voteItem.VoteType === 0"
          >
            <i class="iconfont icon-banjiangdianli"></i>
            颁奖典礼
          </el-button>
        </div>
        <div class="award_ceremony_item_body">
          <el-card
            class="box-card"
            v-for="(item, index) in voteItem.ScreenVoteGroups"
            :key="index"
            style="margin-bottom: 10px"
          >
            <div slot="header" class="clearfix">
              <span> {{ '（' + item.Number + '）' + item.Name }}</span>
              <el-button
                @click="openGroupAwardCeremony(voteItem, item)"
                size="mini"
                plain
                style="float: right"
              >
                <i class="iconfont icon-banjiangdianli"></i>
                颁奖典礼
              </el-button>
            </div>
            <div
              v-for="(project, projectIndex) in item.ChairScreenVoteProjects"
              :key="projectIndex"
              class="text item"
            >
              <div>{{ project.Number }}）{{ project.ProjectName }}</div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <div class="mobile_vote_foot">
      <div class="audio_operate_box">
        <el-link
          icon="iconfont icon-playCircle"
          class="audio_operate_btn"
          @click="changeAudio('play')"
        ></el-link>
        <el-link
          icon="iconfont icon-pauseCircle"
          class="audio_operate_btn"
          @click="changeAudio('pause')"
        ></el-link>
        <el-link
          icon="iconfont icon-chongbo"
          class="audio_operate_btn"
          @click="changeAudio('replay')"
        ></el-link>
        <el-popover placement="top" width="260" trigger="click">
          <div
            style="
              display: -webkit-flex;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: space-around;
              align-items: center;
            "
          >
            <i class="iconfont icon-shengyintianchong"></i>
            <div style="width: 160px">
              <el-slider
                :show-tooltip="false"
                v-model="audioVolume"
                :min="0"
                :max="100"
                @change="changeVolume()"
              ></el-slider>
            </div>
            <span style="width: 30px">{{ audioVolume }}</span>
          </div>
          <el-link
            icon="iconfont icon-shengyintianchong"
            class="audio_operate_btn"
            slot="reference"
          ></el-link>
        </el-popover>
      </div>
      <el-divider direction="vertical"></el-divider>
      <el-link @click="goBack()"> 返回投票列表 </el-link>
    </div>
  </div>
</template>
<script>
import screenApi from '../../../api/mobileVote/screen'
export default {
  data () {
    return {
      awardCeremonyScreenVoteList: [],
      activeNames: [],
      cuuerVoteId: null,
      audioVolume: 100
    }
  },
  methods: {
    goBack: function () {
      this.$router.push({ name: 'voteList', params: { mid: this.$route.params.mid } })
    },
    refreshList: function () {
      this.getAwardCeremonyScreenVoteList()
    },
    getAwardCeremonyScreenVoteList: function () {
      const _this = this
      const openLoading = _this.openLoading()
      screenApi.getAwardCeremonyScreenVoteList({
        meetingId: _this.$route.params.mid
      }).then(data => {
        _this.awardCeremonyScreenVoteList = data
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    openAwardCeremony: function (item) {
      const _this = this
      const openLoading = _this.openLoading()
      screenApi.openScreenVoteAwardCeremony({
        MeetingId: _this.$route.params.mid,
        VoteId: item.VoteId,
        VoteType: item.VoteType,
        SendVoteId: _this.cuuerVoteId
      }).then(data => {
        _this.cuuerVoteId = item.VoteId
        _this.$message({
          type: 'success',
          message: '进入投票“' + item.VoteName + '”的颁奖典礼'
        })
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    openGroupAwardCeremony: function (voteItem, grouptItem) {
      const _this = this
      const openLoading = _this.openLoading()
      screenApi.openScreenVoteAwardCeremony({
        MeetingId: _this.$route.params.mid,
        VoteId: voteItem.VoteId,
        VoteType: voteItem.VoteType,
        GroupId: grouptItem.Id,
        SendVoteId: _this.cuuerVoteId
      }).then(data => {
        _this.cuuerVoteId = voteItem.VoteId
        _this.$message({
          type: 'success',
          message: '进入分组“' + grouptItem.Name + '”的颁奖典礼'
        })
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    changeAudio: function (operate) {
      this.controlLoading = true
      screenApi.screenAudioOperate({
        AudioOperate: operate,
        meetingId: this.$route.params.mid,
        voteId: this.cuuerVoteId
      }).then(data => {
        this.controlLoading = false
      }).catch(err => {
        this.controlLoading = false
        return err
      })
    },
    changeVolume: function () {
      this.controlLoading = true
      screenApi.screenAudioOperate({
        AudioOperate: 'changeVolume',
        meetingId: this.$route.params.mid,
        voteId: this.cuuerVoteId,
        volume: this.audioVolume
      }).then(data => {
        this.controlLoading = false
      }).catch(err => {
        this.controlLoading = false
        return err
      })
    }
  },
  created () {
    this.cuuerVoteId = this.$route.params.vid
    this.getAwardCeremonyScreenVoteList()
  }
}
</script>

<style lang="less">
@import '../../../assets/css/mobileVote/vote.css';
.award_ceremony_item {
  padding: 10px 10px;
  border-style: solid;
  border-width: 1px 1px 1px 1px;
  border-color: #eaeefb;
  background-color: #fafafa;
  margin: 10px 10px;
  border-radius: 4px;
}
.award_ceremony_item_head {
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
}
.award_ceremony_item_head_title {
  flex-grow: 1;
  font-size: 18px;
  font-weight: bold;
}
.award_ceremony_item_head_btn {
}
.award_ceremony_item_body {
}
.audio_operate_box {
  margin: 0px;
}
.audio_operate_box .audio_operate_btn {
  margin: 0px 10px;
}
.audio_operate_box .audio_operate_btn i {
  font-size: 18px;
  margin: 0px;
}
.audio_operate_box .audio_operate_btn i:active {
  font-size: 22px;
  margin: 0px;
}
</style>
